export const ALCHEMY_POK_TOKEN_IDS = [
  583, 611, 674, 853, 1006, 1007, 1416, 1417, 1418, 1577,
];

export const generateTwitterShareLink = (username: string, nftId: string) => {
  if (!ALCHEMY_POK_TOKEN_IDS.includes(Number(nftId))) {
    return `https://twitter.com/intent/tweet?text=Just%20claimed%20my%20Kudos%20via%20%40mintkudosXYZ%20%F0%9F%8E%89%0A%0Ahttps%3A//mintkudos.xyz/profile/${username}?tokenId=${nftId}%26tab=Received`;
  }

  // right now it's only Alchemy
  const copyBody =
    "LFG%21%20i%20just%20minted%20a%20free%20Proof%20of%20Knowledge%20NFT%20recognizing%20my%20web3%20dev%20skills%20with%20@mintkudosXYZ%20🎉%0A%0Ajoin%20me%20on%20@TheRoadToWeb3%20w/%20@AlchemyPlatform%20%26%20let%27s%20build%20together%21%0A%0Ahttps://alchemy.com/road-to-web3";
  return `https://twitter.com/intent/tweet?text=${copyBody}`;
};
